import React from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import AvisoPrivacidadContenido from './AvisoPrivacidadContenido'

const ModalAvisoPrivacidad = ({ show, onHide, onClick }) => {
  return (
    <Modal
        show = {show}
        onExit={onHide}
        centered
        className='modal-alerta modal-aviso-privacidad'
    >
        <Modal.Header closeButton onClick={onHide}></Modal.Header>
        <Modal.Body>
            <AvisoPrivacidadContenido />
            <Row className='justify-content-center'>
                <Form.Group as={Col} xs="6" className="mt-5 mb-3" >
                    <Button type="button" className="btn btn-light w-100" onClick={onHide} >Cancelar</Button>
                </Form.Group>
                <Form.Group as={Col} xs="6" className="mt-5 mb-3" >
                    <Button type="button" className="btn btn-primary w-100" onClick={onClick} >Acepto</Button>
                </Form.Group>
            </Row>
        </Modal.Body>
    </Modal>
  )
}

export default ModalAvisoPrivacidad
